module.exports = __webpack_public_path__ + "static/hejsan-figur1-3520397b94b6ce5e6efe29372809c16a.png";